/**
 * This file was auto-generated by Fern from our API Definition.
 */

import * as Truvity from '../../api/index';
import * as core from '../../core';
import * as serializers from '../index';
import { ResourcePresentation } from './ResourcePresentation';

export const ListPresentation: core.serialization.ObjectSchema<
    serializers.ListPresentation.Raw,
    Truvity.ListPresentation
> = core.serialization.object({
    items: core.serialization.list(ResourcePresentation),
});

export declare namespace ListPresentation {
    export interface Raw {
        items: ResourcePresentation.Raw[];
    }
}
